import { render, staticRenderFns } from "./BcbCustomerExamResultView.vue?vue&type=template&id=481e2df3&scoped=true"
import script from "./BcbCustomerExamResultView.vue?vue&type=script&lang=js"
export * from "./BcbCustomerExamResultView.vue?vue&type=script&lang=js"
import style0 from "./BcbCustomerExamResultView.vue?vue&type=style&index=0&id=481e2df3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481e2df3",
  null
  
)

export default component.exports